export default __webpack_public_path__ + "static/media/career-06.b32fc986.jpg";